import styled from 'styled-components';

const Title = styled.div`
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  display: flex;
`;

export default Title;
